// AdSense.tsx
"use client";
import { initGlobals } from "@/lib/adsenseManager";
import Script from "next/script";
import { useEffect } from "react";
type AdSenseProps = {
  pId: string;
};

const AdSense = ({ pId }: AdSenseProps) => {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      return;
    }
    // Inicializar variables globales de seguimiento
    initGlobals();
  }, []);

  if (process.env.NODE_ENV === "development") {
    return null;
  }
  return (
    <Script
      id="adsense-script"
      async
      src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-${pId}`}
      crossOrigin="anonymous"
      strategy="lazyOnload"
      onLoad={() => {
        if (typeof window !== "undefined") {
          window.adsenseInitialized = true;
        }
      }}
    />
  );
};

export default AdSense;
